let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eyelJ")).then(() => parcelRequire('c9uYh'));